import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <section className="relative py-20 md:py-24 bg-background-50">
          <div className="max-w-3xl mx-auto px-6 md:px-10">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-background-200 text-sm font-medium text-foreground-600 transition-colors cursor-pointer whitespace-nowrap mb-10"
            >
              <i className="ri-arrow-left-line"></i>
              返回主頁
            </button>

            <div className="mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-800 text-xs font-semibold tracking-widest uppercase mb-6 whitespace-nowrap">
                <i className="ri-shield-check-line"></i>
                Privacy Policy · 私隱條款
              </div>
              <h1 className="font-heading text-3xl md:text-4xl font-medium text-foreground-950 leading-tight">
                私隱條款
              </h1>
              <p className="mt-2 text-sm text-foreground-500">
                最後更新日期：2026 年 7 月 22 日
              </p>
            </div>

            <div className="space-y-8 text-sm md:text-base text-foreground-700 leading-[1.8]">
              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  1. 資料收集聲明
                </h2>
                <p>
                  1mindlab（以下稱「本網站」）尊重並保護每一位訪客嘅個人私隱。本網站目前並不會主動收集任何可用於識別個人身份嘅敏感資料（例如姓名、身份證號碼、住址或電話號碼）。
                </p>
                <p className="mt-2">
                  如你透過「聯絡我們」頁面自願提供電郵地址或聯絡資料，該等資料僅用於回覆你嘅查詢，不會被出售、轉讓或用於任何未經你同意嘅第三方推廣用途。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  2. Cookie 與類似技術之使用
                </h2>
                <p>
                  本網站可能使用小型文字檔案（Cookies）及類似技術，以改善用戶體驗、分析網站流量及記住你嘅偏好設定。你可以透過瀏覽器設定選擇拒絕 Cookies，但此舉可能影響部分功能之正常運作。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  3. 第三方服務與外部連結
                </h2>
                <p>
                  本網站可能包含前往第三方網站（例如 Instagram、YouTube 或合作夥伴網站）嘅連結。該等網站擁有獨立嘅私隱政策，本網站不對其內容或資料處理方式負責。建議你在離開本網站後，細閱相關第三方之私隱條款。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  3a. Google AdSense 與廣告 Cookie
                </h2>
                <p>
                  本網站目前使用或將來可能使用 Google AdSense 等第三方廣告平台展示相關廣告。Google 作為第三方供應商，會使用 Cookie（稱為 DART Cookie）根據用戶瀏覽本網站及其他網站之記錄，提供適切嘅廣告內容。
                </p>
                <p className="mt-2">
                  用戶可以透過訪問{' '}
                  <a
                    href="https://policies.google.com/technologies/ads"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-primary-600 hover:text-primary-700 underline underline-offset-4 decoration-primary-300 transition-colors"
                  >
                    Google 廣告政策頁面
                  </a>{' '}
                  了解 Google 如何使用廣告 Cookie，並選擇退出個人化廣告。本網站遵守 Google AdSense 計劃政策及所有適用之廣告規範。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  4. 用戶權利
                </h2>
                <p>
                  根據適用嘅資料保護法例，你有權查閱、更正或刪除本網站持有關於你嘅任何個人資料。如你希望行使上述權利，請透過「聯絡我們」頁面與我哋聯絡，我哋會於合理時間內作出回應。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  5. 資料安全
                </h2>
                <p>
                  本網站採取合理嘅技術及組織措施，保障你嘅個人資料免受未經授權嘅存取、更改、披露或銷毀。然而，互聯網傳輸並非絕對安全，我哋無法保證資料傳送過程中百分百不會被攔截。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  6. 條款修訂
                </h2>
                <p>
                  本網站保留隨時修改本私隱條款嘅權利。任何重大變更將於本頁面公佈，並更新「最後更新日期」。建議你定期查閱本頁，以確保了解最新版本之內容。
                </p>
              </section>

              <section>
                <h2 className="font-heading text-lg md:text-xl font-medium text-foreground-950 mb-3">
                  7. 聯絡我們
                </h2>
                <p>
                  如對本私隱條款有任何疑問，歡迎透過本網站「聯絡我們」頁面與我哋聯絡。
                </p>
              </section>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}